module.exports = __webpack_public_path__ + "static/media/reception.7e683ff9.jpg";